import { IfSrchV3Item, IfSrchV3Req, SrchV3Req } from 'api/srch-v3/srch-v3-model';
import { DOC_TYPE } from 'definitions/DocType';
import { IfDlCenterReq, IfDlCenterRes } from 'pages/dlcenter/dlcenter-model';
import { dlDocTypesArr } from 'pages/dlcenter/leftpanel/DocTypes';

export const getDefaultDlCenterReq = (siteLang: string, targets: number[]): IfDlCenterReq => ({
  ctgryIds: [],
  langs: [siteLang],
  fileLangs: [],
  docTypes: [...dlDocTypesArr],
  tags: [],
  targets: [...targets],
  pageNo: 1,
  pageSize: 20,
  period: '',
  order: 'UPDATE',
  keyword: '',
});

const pickFilterFields = (req: IfDlCenterReq) => ({
  ctgryIds: [...req.ctgryIds].sort((a, b) => a - b),
  langs: [...req.langs].sort(),
  docTypes: [...req.docTypes].sort(),
  tags: [...req.tags].sort(),
  targets: [...req.targets].sort((a, b) => a - b),
  period: req.period,
  order: req.order,
  keyword: req.keyword,
});

export const hasDlCenterFilterChange = (req: IfDlCenterReq, defaultReq: IfDlCenterReq) => {
  return JSON.stringify(pickFilterFields(req)) !== JSON.stringify(pickFilterFields(defaultReq));
};

const toStartOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const getDaterangeFromPeriod = (period: string) => {
  if (!period) return undefined;
  const end = toStartOfDay(new Date());
  end.setDate(end.getDate() + 1); // end 일자는 다음날 0시 0분 0초로 설정
  const start = toStartOfDay(new Date());
  if (period === 'WEEK') start.setDate(start.getDate() - 7);
  else if (period === 'ONEMONTH') start.setMonth(start.getMonth() - 1);
  else if (period === 'SIXMONTH') start.setMonth(start.getMonth() - 6);
  else if (period === 'YEAR') start.setFullYear(start.getFullYear() - 1);
  else return undefined;
  return { start, end };
};

const getSortFromOrder = (order: string): IfSrchV3Req['sort'] => {
  switch (order) {
    case 'ACCURACY':
      return { field: '', sort: 'SCORE' };
    case 'OLDEST':
      return { field: 'update_time', sort: 'ASC' };
    case 'TITLE':
      return { field: 'doc_title.sort', sort: 'ASC' };
    case 'MOST_VIEWED':
      return { field: 'click_count', sort: 'DESC' };
    case 'UPDATE':
    default:
      return { field: 'update_time', sort: 'DESC' };
  }
};

/**
 * 카테고리에서, 모든 하위 카테고리를 가져오고 난 다음,
 * 이를 중복제거하여 사용하는 방식으로 처리.
 */

export const dlCenterReqToSrchV3Req = (req: IfDlCenterReq): IfSrchV3Req => {
  const srchReq = new SrchV3Req();
  srchReq.query = req.keyword || undefined;
  srchReq.page = req.pageNo;
  srchReq.indexsize = req.pageSize;
  srchReq.totalsize = req.pageSize;
  srchReq.index = 'all';
  srchReq.sort = getSortFromOrder(req.order);
  srchReq.daterange = getDaterangeFromPeriod(req.period);
  srchReq.filter = {
    exposeSiteLanguage: req.langs[0],
    docType: req.docTypes as DOC_TYPE[],
    displayTarget: req.targets.length > 0 ? req.targets : undefined,
    categoryId: req.ctgryIds.length > 0 ? req.ctgryIds : undefined,
    tag: req.tags.length > 0 ? req.tags : undefined,
  };
  return srchReq;
};

export const srchV3ItemToDlCenterRes = (item: IfSrchV3Item): IfDlCenterRes => {
  return {
    id: item.id,
    exposeSiteLanguage: item.expose_site_language,
    docType: item.doc_type,
    discontinue: false,
    docTitle: item.doc_title ?? '',
    //tags: item.tag ? item.tag.split(/\s+/).filter(Boolean) : [],

    tags: item.tag ?? [],
    updateTime: item.update_time ? item.update_time.toISOString() : '',
    clickCount: item.click_count ?? 0,
    goodCount: item.good_count ?? 0,
    badCount: item.bad_count ?? 0,
    files: [],
    writerId: item.writer_id ?? '',
    docGrpId: 0,
    displayTarget: item.display_target ?? 0,
    lastModifierId: item.last_modifier_id ?? '',
  };
};
